import { render, staticRenderFns } from "./ProductGridSkeleton.vue?vue&type=template&id=70304fda&scoped=true&"
import script from "./ProductGridSkeleton.vue?vue&type=script&lang=js&"
export * from "./ProductGridSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ProductGridSkeleton.vue?vue&type=style&index=0&id=70304fda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70304fda",
  null
  
)

export default component.exports